import request from 'services/axios'

const URL = '/messaging/topics/'

/** Every fund of the member with only the sections that are theirs. */
export const getMessagingTopics = async () => {
    const { data } = await request.get<ITopicsResponse>(URL)
    return data
}

/** Flip one switch of one fund. Answers with that fund again. */
export const updateMessagingTopic = async (
    box: string,
    topic: string,
    enabled: boolean
) => {
    const { data } = await request.patch(URL, { box, topic, enabled })
    return data as ITopicFund
}

/** «هر بار» ('') or «خلاصهٔ روزانه» ('daily'). Answers with that fund again. */
export const setMessagingTopicMode = async (
    box: string,
    topic: string,
    mode: string
) => {
    const { data } = await request.patch(URL, { box, topic, mode })
    return data as ITopicFund
}

/**
 * «ارسال آزمایشی» — one message down the real road (بله، then ایتا، then
 * پیامک). At most once every two hours: the backend answers 429 with
 * `next_at` inside that window.
 */
export const sendTestMessage = async () => {
    const { data } = await request.post('/messaging/test-send/')
    return data as ITestSendResponse
}

/** A manager's invite link into the mini apps, for one fund. */
export interface IFundInvite {
    code: string
    urls: { web: string; bale: string; eitaa: string }
    /** what to post in the fund's group (J1) */
    text: string
    stats: { landing_views: number; opened: number; joined: number }
    reach: { total: number; messenger: number; off: number }
}

export const getFundInvite = async (
    moneyPool: string | number
): Promise<IFundInvite> => {
    const { data } = await request.get<IFundInvite>(
        `/messaging/invite/?box=moneypool-${moneyPool}`
    )
    return data
}
